<template>
  <div>
    <breadcrumb :breadcrumb="breadcrumb" />
    <div class="search-line">
      <div class="btn-box">
        <button-add :pathName="addBusinessRouterName" v-if="permissionCodes.indexOf('001002006') !== -1"/>
        <button-delete @deleteSelection="deleteSelection" />
      </div>
      <input-search placeholder="标题" @search="searchKey" />
    </div>
    <table-main :tableHead="tableHead" :tableData="tableData" @deleteLine="deleteLine" :deleteTipInfo="'是否确认删除宣传视频？'" @goToModifyPage="goToModifyPage" @changeSelection="changeSelection" :total="total" :pageNum="requestData.pageNum" :pageSize="requestData.pageSize" :operationArr="operationArr" @changePagination="changePagination" />


    <!--<el-dialog title="修改宣传信息" :visible.sync="dialogFormVisible">-->
      <!--<div class="form-line">-->
        <!--<div class="textBox">-->
          <!--<b class="red">*</b>-->
          <!--<span class="line-text">标题：</span>-->
        <!--</div>-->
        <!--<el-input v-model="videoInfo.header" size="small" style="width: 280px" />-->
      <!--</div>-->
      <!--<div class="form-line">-->
        <!--<div class="textBox" style="vertical-align: top">-->
          <!--<span class="line-text">备注：</span>-->
        <!--</div>-->
        <!--<el-input type="textarea" :rows="3" v-model="videoInfo.memo" size="small" style="width: 280px" />-->
      <!--</div>-->
      <!--<div slot="footer" class="dialog-footer">-->
        <!--<el-button @click="dialogFormVisible = false">取 消</el-button>-->
        <!--<el-button type="primary" @click="updateyqVideo">确 定</el-button>-->
      <!--</div>-->
    <!--</el-dialog>-->

  </div>
</template>

<script>
import Breadcrumb from '../../../components/Breadcrumb/Breadcrumb'
import ButtonAdd from '../../../components/Button/ButtonAdd'
import ButtonDelete from '../../../components/Button/ButtonDelete'
import ButtonExport from '../../../components/common/buttons/button-export'
import ButtonUpload from '../../../components/common/buttons/button-upload'
import InputSearch from '../../../components/Input/InputSearch'
import InputSelect from '../../../components/Input/InputSelect'
import TableMain from '../../../components/Table/TableMain'
import {api} from '../../api/yqVideo'
import {errorHandler} from '../../../utils/errorHandler'
import {nAlert, nError, nSuccess} from '../../../utils/notice'
import {bus} from '../../../utils/bus'

export default {
  components: {
    TableMain,
    InputSelect,
    InputSearch,
    ButtonUpload,
    ButtonExport,
    ButtonDelete,
    ButtonAdd,
    Breadcrumb},
  name: 'yq-video-management',
  data () {
    return {
      permissionCodes: '',
      breadcrumb: [{
        value: '资源中心',
        name: 'yq-information'
      }, {
        value: '视频宣传'
      }],
      addBusinessRouterName: 'add-yq-video',
      selectTitle: '租赁状态',
      operationArr: ['modify', 'delete'],
      tableHead: [{
        prop: 'header',
        label: '标题'
      }, {
        prop: 'videoUrl',
        label: '视频ID'
      }, {
        prop: 'memo',
        label: '备注'
      }],
      tableData: [],
      total: 0,
      selectionArr: [],
      requestData: {
        searchKey: '',
        pageSize: 10,
        pageNum: 1,
      },
      dialogFormVisible: false,
      videoInfo: {}
    }
  },
  created () {
    this.permissionCodes = bus.global.permissionCodes
    this.getPage()
  },
  methods: {
    getPage () {
      this.$axios.post(api.getYqVideoPage, this.requestData)
        .then(res => {
          if (res.data.retCode === 1) {
            let data = res.data.data.list
            this.total = res.data.data.total
            this.tableData = data
          }
        })
        .catch(errorHandler('获取视频信息失败'))
    },
    search (v) {
      this.requestData[v.key] = v.value
      this.getPage()
    },
    searchKey (v) {
      this.requestData.searchKey = v
      this.getPage()
    },
    changePagination (data) {
      this.requestData.pageNum = data[0]
      this.requestData.pageSize = data[1]
      this.getPage()
    },
    changeSelection (codeArr) {
      this.selectionArr = codeArr
    },
    goToModifyPage (code) {
      let header = ''
      let videoUrl = ''
      let memo = ''
      this.tableData.map(v => {
        if (v.code === code) {
          header = v.header
          videoUrl = v.videoUrl
          memo = v.memo
        }
      })
      this.$router.push({
        path: `/modify_yq_video/${code}`,
        query: {
          header,
          videoUrl,
          memo
        }
      })

      // this.dialogFormVisible = true
    },
    updateyqVideo () {
      if (!this.videoInfo.header) {
        nError('请输入宣传标题')
        return false
      }
      this.$axios.post(api.updateyqVideo, this.videoInfo)
        .then(res => {
          if (res.data.retCode === 1) {
            nSuccess('修改成功')
            this.dialogFormVisible = false
            this.getPage()
          }
        })
        .catch(errorHandler('修改宣传信息失败'))
    },
    deleteSelection () {
      if (this.selectionArr.length === 0) {
        nAlert('请先选择需要删除的宣传视频')
        return false
      } else {
        this.$confirm('是否确认删除宣传视频？', '提示')
          .then(() => {
            this.deleteLine(this.selectionArr)
          })
          .catch(() => {
            console.log('取消删除')
          })
      }
    },
    deleteLine (code) {
      this.$axios.post(api.deleteyqVideoByCodes, code)
        .then(res => {
          if (res.data.retCode === 1) {
            nSuccess('删除成功')
            this.selectionArr = []
            this.getPage()
          }
        })
        .catch(errorHandler('删除宣传视频失败'))
    }
  },
  watch: {
    centEndTime(val) {
      this.getPage()
    }
  }
}
</script>

<style scoped>
  .form-line {
    width: 420px;
    margin: 20px auto;
    display: flex;
    justify-content: flex-start;
  }
  .form-line>div {
    margin-right: 20px;
  }
  .line-text{
    color: #48576a;
    font-size: 14px;
    margin-right: 10px;
  }
  .textBox {
    display: inline-block;
    width: 122px;
    line-height: 32px;
    text-align: right;
  }
  .red {
    color: red;
  }
  .search-line {
    display: flex;
    justify-content: space-between;
    margin: 20px 0;
  }
  .btn-box {
    display: flex;
    justify-content: flex-start;
  }
</style>



// WEBPACK FOOTER //
// src/view/ResourceCenter/ParkVideoManagement/ParkVideoManagement.vue